import React from "react";
import "./portfolio.css";
import { Rate } from "antd";

import {
  HeartTwoTone,
  BookOutlined,
  ShopOutlined,
  SaveOutlined,
  NotificationOutlined,
} from "@ant-design/icons";

import { CiSearch, CiHeart } from "react-icons/ci";

const Card = ({ name, desc, img, lowerDesc, loc, keyword, tab }) => {
  const hoverRef = React.useRef(null);

  if (hoverRef.current) {
    hoverRef.current.style.opacity = 0;
  }

  return (
    <header
      onMouseOver={() => {
        hoverRef.current.style.opacity = 0.8;
      }}
      onMouseLeave={() => {
        hoverRef.current.style.opacity = 0;
      }}
    >
      <img src={`../img/${img}`} alt="Clinic Image" />

      <p className="tabName">{tab}</p>

      <p className="heading">{name}</p>

      <p className="line"></p>

      <p className="loc">Location &nbsp; &nbsp; {loc}</p>

      <p className="key">Keyword &nbsp; &nbsp; {keyword}</p>

      <p className="line"></p>

      <p className="lowerDesc">{lowerDesc}</p>

      <div ref={hoverRef} className="hoverEle">
        <h2>{desc}</h2>
        <div>
          <CiSearch />
          <CiHeart />
        </div>
      </div>

      {/* <h2 class="topic">{desc}</h2> */}

      {/* <div class="info-icons">
              <div class="icon">
                <BookOutlined style={{ fontSize: "22px", color: "#96C9F4" }} />
                <p>内科</p>
              </div>

              <div class="icon">
                <ShopOutlined style={{ fontSize: "22px", color: "#96C9F4" }} />
                <p>内視鏡</p>
              </div>

              <div class="icon">
                <SaveOutlined style={{ fontSize: "22px", color: "#96C9F4" }} />
                <p>肛門科</p>
              </div>

              <div class="icon">
                <NotificationOutlined
                  style={{ fontSize: "22px", color: "#96C9F4" }}
                />
                <p>消化器科</p>
              </div>
            </div> */}
    </header>
  );
};

export default Card;
